import { SECTIONS } from '../data/sections';
import { ROLES, PHASES } from '../data/roles';
import { PROCESS_META } from '../data/processMeta';
import { getSectionProgress } from './progress';

// ── CSV helpers ───────────────────────────────────────────────────
function escCsv(val) {
  if (val === null || val === undefined) return '';
  const s = String(val);
  if (s.includes(',') || s.includes('"') || s.includes('\n')) {
    return '"' + s.replace(/"/g, '""') + '"';
  }
  return s;
}

function rowToCsv(cells) {
  return cells.map(escCsv).join(',');
}

// ── Excel (XLSX) as base64 via SheetJS CDN approach ──────────────
// We build a proper CSV that Excel opens natively
export function exportProgressCSV(state, roleKey) {
  const role = ROLES[roleKey];
  if (!role) return;

  const now = new Date();
  const dateStr = now.toISOString().split('T')[0];
  const timeStr = now.toTimeString().split(' ')[0];

  const rows = [];

  // Header row
  rows.push(rowToCsv([
    'Phase', 'Phase Title', 'Section', 'Section Title',
    'Step #', 'Step Description', 'Responsible',
    'Status', 'Date Completed', 'Notes', 'Evidence / Reference',
    'Is Critical', 'Has Prerequisites', 'Can Run In Parallel With',
    'Overall Section %',
  ]));

  PHASES.forEach(ph => {
    const rel = ph.keys.filter(k => role.sections.includes(k));
    rel.forEach(sk => {
      const sec  = SECTIONS[sk];
      const meta = PROCESS_META[sk] || {};
      const sp   = getSectionProgress(state.progress, sk);

      sec.checklist.forEach(([step, owner], i) => {
        const d = state.progress?.[sk]?.[i] || {};
        rows.push(rowToCsv([
          ph.code,
          ph.title,
          sk,
          sec.title,
          i + 1,
          step,
          owner,
          d.status || 'Not Started',
          d.date   || '',
          d.notes  || '',
          d.evidence || '',
          meta.critical ? 'Yes' : 'No',
          (meta.prerequisites?.length > 0) ? meta.prerequisites.join(' | ') : 'None',
          (meta.parallel?.length > 0) ? meta.parallel.join(' | ') : 'None',
          sp.pct + '%',
        ]));
      });
    });
  });

  // Summary rows at the bottom
  rows.push('');
  rows.push(rowToCsv(['SUMMARY','','','','','','','','','','','','','','']));
  rows.push(rowToCsv(['Role', roleKey, '', '', '', '', '', '', '', '', '', '', '', '', '']));
  rows.push(rowToCsv(['Role Label', role.label, '', '', '', '', '', '', '', '', '', '', '', '', '']));
  rows.push(rowToCsv(['Export Date', dateStr, '', '', '', '', '', '', '', '', '', '', '', '', '']));
  rows.push(rowToCsv(['Export Time', timeStr, '', '', '', '', '', '', '', '', '', '', '', '', '']));

  // Per-phase summary
  rows.push('');
  rows.push(rowToCsv(['Phase', 'Title', 'Sections', 'Total Steps', 'Done', 'In Progress', 'Blocked', 'Completion %', '', '', '', '', '', '', '']));
  PHASES.forEach(ph => {
    const rel = ph.keys.filter(k => role.sections.includes(k));
    if (!rel.length) return;
    let t=0, d=0, inp=0, blk=0;
    rel.forEach(k => {
      const sp = getSectionProgress(state.progress, k);
      t += sp.total; d += sp.done; inp += sp.inProg; blk += sp.blocked;
    });
    const pct = t ? Math.round(d/t*100) : 0;
    rows.push(rowToCsv([ph.code, ph.title, rel.join(' '), t, d, inp, blk, pct+'%','','','','','','','']));
  });

  const csvContent = rows.join('\n');
  const blob = new Blob(['\uFEFF' + csvContent], { type: 'text/csv;charset=utf-8;' });
  const url  = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href     = url;
  link.download = `SWISO_Process_Progress_${roleKey}_${dateStr}.csv`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}

// ── Export Process Tree as SVG ────────────────────────────────────
export function exportTreeSVG(svgElement, roleKey) {
  if (!svgElement) return;
  const dateStr = new Date().toISOString().split('T')[0];
  const svgData = new XMLSerializer().serializeToString(svgElement);
  const blob    = new Blob([svgData], { type: 'image/svg+xml' });
  const url     = URL.createObjectURL(blob);
  const link    = document.createElement('a');
  link.href     = url;
  link.download = `SWISO_ProcessTree_${roleKey}_${dateStr}.svg`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
